import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import { NavLink } from 'react-router-dom'
import ActionLogs from './ActionLogs';


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;

var token= ''
var bizuserid= ''


class ApplicantActions extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    datarequested:true,
    action_logs:[],


  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  this.setState({datarequested:false})

}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {
    const columns = [
    
      {
        title: 'Action',
        dataIndex: 'action_name',
        key: 'id',
        render: (text,record) =>
          <p style={{display:'flex',flexDirection:'column'}}>
            <span>{record.action_name}</span>
            {
              record.status==="Submitted"?
              <NavLink to={`/complete_action/${record.id}`}><span>Review & Complete</span></NavLink>
              :null
            }
          </p>
      },
      {
        title: 'Prompt Message',
        dataIndex: 'prompt_message',
        key: 'id',
      },
      {
        title: 'Prompt Time',
        dataIndex: 'prompt_time',
        key: 'id',
      },
      
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'id',
      },

      {
        title: 'Submitted At',
        dataIndex: 'submitted_at',
        key: 'id',
      },

      {
        title: 'Completed At',
        dataIndex: 'completed_at',
        key: 'id',
      },
      {
        title: 'Requirements',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
          <p>
            {
             JSON.parse(record.required_fields).length>0?
             <span>
              {
                JSON.parse(record.required_fields).map((item)=>{
                  return (item.label+",")
                })
              }
             </span>
             :
             null 
            }
        </p>
      },
      
     
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

            <Table 
            columns={columns} 
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.props.applicant_actions}
            bordered
            
            expandable={{
              expandedRowRender: (record) =>{
                  return (
                    <div>
                        <Tabs
                          defaultActiveKey="1"
                          onChange={() => {}}
                          tabPosition={'top'}
                        >
                          <TabPane tab={"Action Logs ("+this.state.action_logs.length+")"} key="2">
                            <ActionLogs action_logs={this.state.action_logs}  />
                          </TabPane>

                        </Tabs>
                    </div>
                   );
              } ,
              rowExpandable: (record) => true,
              onExpand:(condition,record)=>{

                axios.get(serverconfig.backendserverurl+`/api/action_logs/?applicant_action=${record.id}`)
                .then(res => {
                    this.setState({
                      action_logs:res.data
                    })
              
                })


              },
            }}
            
            />
            
        </div>
    )

    }

   
  }
}

export default ApplicantActions; 
